export default __webpack_public_path__ + "0cdfc6e2743c914ec774e30027a1c7fe.png";